export const isFilterParam = (key: string) => key.startsWith("f_");
